export default __webpack_public_path__ + "static/soups_head_mob-02519169eac3a35abb4068e6dcb4ca73.png";